<template>
    <div class="contentBox">
        <div class="goodsTop">
            <el-cascader
                v-model="platformTypeCode"
                :props="props"
                :options="platformTypeOptions"
                placeholder="商品分类"
            ></el-cascader>
            <el-input
                v-model="goodsName"
                placeholder="商品名称">
            </el-input>
            <el-input
                v-model="storeName"
                placeholder="服务商名称">
            </el-input>
            <div class="timeSearch">
                <span style="color: #b2b2b2;">提交时间</span>
                <el-date-picker
                    v-model="auditCreateDate"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="—"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </div>
            <el-select v-model="auditStatus" placeholder="审核状态">
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="NONE"></el-option>
                <el-option label="审核通过" value="PASS"></el-option>
                <el-option label="审核拒绝" value="FAIL"></el-option>
            </el-select>
            <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>


        </div>
        <div class="goodsListTable">
            <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%" class="tableContent">
                <el-table-column
                    prop="name"
                    label="商品名称"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="fullCategoryName"
                    label="商品分类"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="storeName"
                    label="服务商名称"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="auditCreateTime"
                    align="center"
                    header-align="center"
                    label="提交时间" width="200">
                </el-table-column>
                <el-table-column
                    prop="auditStatus"
                    :formatter="showExamineStatus"
                    align="center"
                    header-align="center"
                    label="状态" width="200">
                </el-table-column>
                <!--<el-table-column
                    prop="auditContent"
                    align="center"
                    header-align="center"
                    label="驳回原因" width="200">
                </el-table-column>-->

                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="scope.row.auditStatus === 'NONE'" @click="toDialog(0,scope.row.uuid,scope.row.auditUuid)">审核
                        </el-button>
                        <el-button type="text" size="small" v-else @click="toDialog(1,scope.row.uuid,scope.row.auditUuid)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <!--审核查看弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="800px">
            <div class="dialogBox" v-loading="auditDetailloading">
                <div class="details">
                    <div class="detailsItem">
                        <h3>基础信息</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">商品名称:</div>
                                <div class="name">{{goodsForm.name}}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">店铺中分类:</div>
                                <div class="name">{{goodsForm.storeTypeName}}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">商品品牌:</div>
                                <div class="name">{{goodsForm.brand}}</div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="detailsItem">
                        <h3>类目属性</h3>
                        &lt;!&ndash;3D打印机&ndash;&gt;
                        <div>
                            <div class="itemContent">
                                <div class="one-row">
                                    <div class="label">品牌:</div>
                                    <div class="name">品牌品牌品牌品牌品牌</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">型号:</div>
                                    <div class="name">型号型号型号型号型号</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">上市时间:</div>
                                    <div class="name">2021-12-10</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">耗材类型:</div>
                                    <div class="name">耗材类型耗材类型耗材类型耗材类型耗材类型耗材类型</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">产品长度:</div>
                                    <div class="name">110mm</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">产品宽度:</div>
                                    <div class="name">110mm</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">产品高度:</div>
                                    <div class="name">110mm</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">产品净重:</div>
                                    <div class="name">10kg</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">打印精度:</div>
                                    <div class="name">101mm</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">喷头数量:</div>
                                    <div class="name">单喷头</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">技术类型:</div>
                                    <div class="name">技术类型技术类型技术类型技术类型</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">是否整装:</div>
                                    <div class="name">是</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">分类类别:</div>
                                    <div class="name">准工业级</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">应用领域:</div>
                                    <div class="name">应用领域应用领域应用领域应用领域应用领域应用领域</div>
                                </div>
                                <div class="two-row">
                                    <div class="label">附加功能:</div>
                                    <div class="name">2K黑白屏，3倍快速打印，活性炭过滤系统，出错报警，自动关机，平台加热，断电续打，断点续打，自动调平，视频监控，断料检测，静音驱动，晶格热床</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">成型高度:</div>
                                    <div class="name">110mm</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">成型宽度:</div>
                                    <div class="name">110mm</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">连接方式:</div>
                                    <div class="name">有线，wifi，U盘，SD卡，蓝牙</div>
                                </div>
                                <div class="one-row">
                                    <div class="label">打印速度:</div>
                                    <div class="name">110mm/s</div>
                                </div>
                            </div>
                        </div>

                    </div>-->
                    <div class="detailsItem">
                        <h3>销售信息</h3>
                        <div class="itemContent">
                            <div class="two-row salesSpecifications">
                                <div class="label">销售规格</div>
                                <div class="tableContent">
                                    <el-table
                                        :data="goodsForm.specificationsList"
                                        style="width: 100%">
                                        <el-table-column
                                            prop="name"
                                            label="规格"
                                            width="180">
                                        </el-table-column>
                                        <el-table-column
                                            prop="imageUrl"
                                            label="规格图片">
                                            <template slot-scope="scope">
                                                <img fit="contain" height="60px" :src="scope.row.filePath" alt="" style="width:60px">
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="price"
                                            label="价格">
                                        </el-table-column>
                                        <el-table-column
                                            prop="amount"
                                            label="数量">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="one-row">
                                <div class="label">总数量:</div>
                                <div class="name">{{goodsForm.totalNumber}}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">商品单位:</div>
                                <div class="name">{{goodsForm.unit}}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">商品推荐:</div>
                                <div class="name">{{goodsForm.isRecommend === true ? '是' : '否'}}</div>
                            </div>
                            <div class="one-row">
                                <div class="label">SEO关键词:</div>
                                <div class="name">{{goodsForm.seoKeyword}}</div>
                            </div>
                            <div class="two-row">
                                <div class="label">SEO描述:</div>
                                <div class="name">{{goodsForm.seoDescription}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem">
                        <h3>物流信息</h3>
                        <div class="itemContent">
                            <div class="one-row">
                                <div class="label">运费:</div>
                                <div class="name">{{goodsForm.freightMethod === 'BUYER' ? '买家承担运费' : '卖家承担运费'}}</div>
                            </div>
                            <div class="one-row" v-if="goodsForm.freightMethod=='BUYER'">
                                <div class="label">物流模板:</div>
                                <div class="name">{{goodsForm.logisticsName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="detailsItem">
                        <h3>详情描述</h3>
                        <div class="itemContent">
                            <div class="two-row commodityImages">
                                <div class="label">商品图片:</div>
                                <div class="imagesContent">
                                    <div class="imgItem" v-for="item in goodsForm.pcGoodsImages" v-if="goodsForm.pcGoodsImages.length>0">
                                        <img :src="item.url" :alt="item.name">
                                    </div>
                                </div>
                            </div>
                            <div class="two-row commodityVideo">
                                <div class="label">主图视频:</div>
                                <div class="videosContent">
                                    <div class="videoItem" v-for="item in goodsForm.pcGoodsVideos" v-if="goodsForm.pcGoodsVideos.length>0">
                                        <video :src="item.url" controls></video>
                                    </div>
                                </div>
                            </div>
                            <div class="two-rows" style="width:100%">
                                <div class="label">PC端详情描述:</div>
                                <div v-html="goodsForm.pcDescription" class="detailImg vHtmlMess"></div>
                            </div>
                            <div class="two-rows" style="width:100%">
                                <div class="label">手机端详情描述:</div>
                                <div v-html="goodsForm.mobileDescription" class="detailImg vHtmlMess"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 1">
                    <h3>审核结果</h3>
                    <div class="auditContent">
                        <el-tag type="success" effect="dark" v-if="auditForm.auditStatus=='PASS'">审核已通过</el-tag>
                        <el-tag type="danger" effect="dark" v-if="auditForm.auditStatus=='FAIL'">审核已驳回</el-tag>
                        <div class="cause" v-if="auditForm.auditStatus=='FAIL'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent">
                                {{auditForm.content}}
                            </div>
                        </div>
                        <div class="auditEnter">
                            <el-button  @click="dialogVisible = false">取消</el-button>
                        </div>
                    </div>
                </div>
                <div class="audit" v-if="currentAudit === 0">
                    <h3>审核</h3>
                    <el-form ref="auditForm" :model="auditForm" :rules="rules" style="disply:flex">
                        <div class="auditContent">
                            <el-radio-group v-model="auditForm.auditStatus">
                                <el-radio label="PASS">通过</el-radio>
                                <el-radio label="FAIL">驳回</el-radio>
                            </el-radio-group>
                            <div class="cause" v-if="auditForm.auditStatus === 'FAIL'">
                                <div class="causeTitle">驳回原因：</div>
                                <div class="causeContent" style="width: 100%">
                                    <el-input
                                        type="textarea"
                                        :autosize="{ minRows: 5 }"
                                        placeholder="请输入驳回原因"
                                        v-model="auditForm.content"
                                    >
                                    </el-input>
                                </div>
                            </div>
                            <div class="auditEnter">
                                <el-button  @click="dialogVisible = false">取消</el-button>
                                <el-button type="primary" @click="auditSubmit">确定</el-button>
                            </div>
                        </div>
                    </el-form>

                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getGoodsList,
        getGoodsAuditList,
        saveGoods,
        updateGoods,
        updateGoodsStatus,
        deleteGoods,
        getGoodsInfo,
        typetree,
        goodsAudit,
        goodsAuditDetail
    } from '../../../utils/interface';
    import tinymce from '@/components/tinymce'
    export default {
        data() {
            return {
                goodsName: '',
                platformTypeCode: '',
                platformTypeOptions: [],

                storeName: '',
                auditCreateDate: [],
                auditStatus: null,
                tableData: [],

                props: {
                    value: 'code',
                    label: 'label',
                    checkStrictly: true
                },
                current:1,
                total: 0,
                pageSize: 8,
                dialogVisible: false,
                title: '',
                auditRadio: "",
                textarea: "",
                currentAudit: "",
                goodsForm:{
                    name: '',
                    platformFirstTypeUuid: '',
                    storeTypeUuid: "",
                    brand: "",
                    totalNumber: "",
                    sort: "",
                    isRecommend: "",
                    unit: "",
                    seoKeyword: "",
                    seoDescription: "",
                    freightMethod: "",
                    logisticsUuid: "",
                    pcDescription: "",
                    mobileDescription: "",
                    status: "",
                    pcGoodsImages: [],
                    pcGoodsVideos: [],
                },
                auditForm:{
                    auditStatus:'',
                    content:''
                },
                rules: {
                    auditStatus: [{required: true, message: '请选择审核结果', trigger: 'blur'}],
                },
                loading:false,
                auditDetailloading:false,
            }
        },
        created() {
            this.platformTypetree();
            this.getList();
        },
        methods: {
            searchInfo(){
                this.current = 1;
                this.getList();
            },
            showExamineStatus(row, column){
                if(row.auditStatus=="PASS"){
                    return "审核通过";
                }else if(row.auditStatus=="NONE"){
                    return "待审核";
                }else if(row.auditStatus=="FAIL"){
                    return "审核拒绝";
                }
            },
            // 清除检索
            reset(){
                this.current = 1;
                this.platformTypeCode = '';
                this.goodsName = '';
                this.auditCreateDate = [];
                this.storeName = '';
                this.auditStatus = null;
                this.getList();
            },
            resetForm(){
                this.goodsForm = {
                    uuid:'',
                    name: '',
                    platformFirstTypeUuid: '',
                    storeTypeUuid: "",
                    brand: "",
                    totalNumber: "",
                    sort: "",
                    isRecommend: "",
                    unit: "",
                    seoKeyword: "",
                    seoDescription: "",
                    freightMethod: "",
                    logisticsUuid: "",
                    pcDescription: "",
                    mobileDescription: "",
                    status: "",
                    pcGoodsImages: [],
                    pcGoodsVideos: [],
                };
                this.auditForm = {
                    uuid:'',
                    auditStatus:'',
                    content:''
                }
            },
            // 审核查看
            toDialog(val,uuid,auditUuid) {
                this.auditDetailloading = true;
                this.dialogVisible = true
                this.currentAudit = val
                if (val === 0) {
                    this.title = '审核详情'
                    this.auditRadio = ''
                    this.textarea = ''
                } else {
                    this.title = '查看详情'
                }
                this.resetForm();
                getGoodsInfo(uuid).then((res)=>{
                    this.goodsForm = res.data
                    this.auditDetailloading = false;
                })
                goodsAuditDetail(auditUuid).then((res)=>{
                    this.auditForm = res.data
                })
            },

            // 确定审核
            auditSubmit() {
                if (this.auditForm.auditStatus === "NONE" || this.auditForm.auditStatus === "") {
                    this.$message.warning("请选择审核结果！");
                }
                else if (this.auditForm.auditStatus === "FAIL" && this.auditForm.content === "") {
                    this.$message.warning("请输入驳回原因！");
                } else {
                    let params = {
                        goodsUuid: this.goodsForm.uuid,
                        uuid: this.auditForm.uuid,
                        auditStatus: this.auditForm.auditStatus,
                        content:this.auditForm.content
                    }
                    goodsAudit(params).then((res) => {
                        if (res.success) {
                            this.$message.success("审核成功！");
                            this.getList()
                        }
                    });
                    this.dialogVisible = false;
                }
            },
            getList(){
                this.loading = true
                let code='';
                let platformTypeCodeArr = this.platformTypeCode;
                if(platformTypeCodeArr.length>0){
                    code = platformTypeCodeArr[platformTypeCodeArr.length-1]
                    console.log('code = '+code)
                }
                let params = {
                    name: this.goodsName,
                    storeName:this.storeName,
                    platformTypeCode: code,
                    auditStatus: this.auditStatus,
                    auditCreateDate:this.auditCreateDate.length>0 ? this.auditCreateDate.join(" - ") : "",
                    current:this.current,
                    pageSize:this.pageSize,
                }
                getGoodsAuditList(params).then((res)=>{
                    this.total = res.total;
                    this.tableData = res.list;
                    this.loading = false
                });
            },
            remove(uuid){
                deleteGoods(uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.getList()
                    }
                });
            },
            // 按钮点击事件 显示新增编辑弹窗组件
            show(){
                this.addOrUpdateVisible = true
            },
            handleDialog(type,uuid){
                if(type == 'edit'){
                    this.$refs.addOrUpdateRef.init(type,uuid)
                }
                if(type=='warn'){
                    this.$refs.warnUpdateRef.init(type)
                }
            },


            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 分页
            handleCurrentChange(val){
                this.current = val
                this.getList()
            },
            // 发布商品
            toReleaseCommodities(){
                this.$router.push('/releaseCommodities')
            },
            storeTypetree() {
                let params = {
                    grade: "1",
                    type: 'STORE'
                }
                typetree(params).then((res) => {
                    this.storeTypeOptions = res;
                });
            },
            platformTypetree() {
                let params = {
                    grade: "3",
                    type: 'PLATFORM'
                }
                typetree(params).then((res) => {
                    this.platformTypeOptions = res;
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .contentBox {
        width: 97%;
        background-color: white;
        margin: auto;
        padding: 20px;
        box-sizing: border-box;

        .goodsTop {
            /deep/.el-cascader{
                line-height: unset;
                height: 35px;
                .el-input__icon{
                    line-height: unset;
                }
            }

            .timeSearch {
                background-color: #f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;

                span {
                    font-size: 12px;
                    color: #c0c4cc !important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }

                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/ input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }

                /deep/ .el-range-input:hover {
                    background-color: #fff !important;
                }

                /deep/ .el-date-editor .el-range-separator {
                    line-height: 25px;
                    color: #c0c4cc;
                }

                /deep/ .el-date-editor .el-range__close-icon {
                    line-height: 28px;
                }

                /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                    background-color: white;
                }

                /deep/ .el-input__inner {
                    width: 225px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    .el-range-input {
                        background-color: #f2f4f7;
                    }

                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;

                    }
                }
            }
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }

        .goodsListTable {

            .tableContent {
                min-height: 600px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }

    }
    .dialogBox {
        .details {
            .detailsItem {
                padding-bottom: 20px;
                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;

                    // padding: 0 30px;
                    .one-row {
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                     /deep/ .detailImg p img{
                            width: 100%!important;
                        }
                    .two-rows{
                         width: 100%;
                        margin-bottom: 22px;
                        // display: flex;
                        //   align-items: center;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                            img {
                                width: 216px;
                            }
                        }
                    }
                    .two-row {
                        width: 100%;
                        margin-bottom: 22px;
                        display: flex;
                          align-items: center;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                            img {
                                width: 216px;
                            }
                        }
                    }
                    .salesSpecifications{
                        display: block;
                        .tableContent{
                            padding: 15px 0;
                            .tableHeader{
                                display: flex;
                                justify-content: space-around;
                                line-height: 40px;
                                background: #f2f5fc;
                            }
                            .tableItem{
                                display: flex;
                                justify-content: space-around;
                                align-items: center;
                                padding: 15px 0;
                                img{
                                    width: 160px;
                                    height: 110px;
                                }
                            }
                            .name{
                                width: 20%;
                                min-width: 20%;
                                text-align: center;
                            }
                            .img{
                                width: 40%;
                                min-width: 40%;
                                text-align: center;
                            }
                        }
                    }
                    .commodityImages{
                        display: block;
                        .imagesContent{
                            padding: 15px 0;
                            display: flex;
                            flex-wrap: wrap;
                            .imgItem{
                                margin-bottom: 10px;
                                width: 25%;
                                text-align: center;
                            }
                            img{
                                width: 160px;
                                height: 110px;
                            }
                        }
                    }
                    .commodityVideo{
                        display: block;
                        .videosContent{
                            padding: 15px 0;
                            display: flex;
                            flex-wrap: wrap;
                            .videoItem{
                                margin-bottom: 10px;
                                width: 50%;
                                text-align: center;
                            }
                        }
                        video{
                            width: 350px;
                            height: 200px;
                        }
                    }
                }
                .itemPictureContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;
                    .one-row {
                        width: 30%;
                        margin-bottom: 22px;
                        img {
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }
                        .name {
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;
                            .label {
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }
        .audit {
            padding-bottom: 20px;
            h3 {
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                // border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent {
                // padding: 0 30px;
            }
            .cause {
                display: flex;
                margin-top: 20px;
                .causeTitle {
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent {
                    color: #000;
                }
            }
            .auditEnter {
                text-align: center;
                padding-top: 20px;
                button {
                    width: 120px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/auditManagement/goodsAudit/goodsAudit.vue